import { ApiError } from "@/api/client";
import {
  getUserFacingErrorMessage,
  ORDER_NOT_FOUND,
} from "@/api/userFacingError";

const ORDER_REQUIRES_CHANGE_REQUEST_PREFIX = "order_requires_change_request:";

export function isOrderRequiresChangeRequestConflict(error: unknown) {
  return (
    error instanceof ApiError &&
    error.status === 409 &&
    error.message.startsWith(ORDER_REQUIRES_CHANGE_REQUEST_PREFIX)
  );
}

export function getOrderMutationErrorMessage(error: unknown) {
  if (!(error instanceof ApiError)) {
    return getUserFacingErrorMessage(error);
  }

  const message = error.message.trim();
  const normalizedMessage = message.toLowerCase();

  if (normalizedMessage.includes("cotação especial")) {
    return "Esta cotação foi atualizada. Recarregue a página e tente novamente.";
  }

  if (normalizedMessage.includes("r$ 1.000.000.000,00")) {
    return message;
  }

  switch (normalizedMessage) {
    case "quotation item not found":
      return "Este item não está mais disponível na cotação. Recarregue a página e tente novamente.";
    case "store not found":
      return "Loja não encontrada. Selecione a loja novamente e tente adicionar o item.";
    case "store does not belong to client":
      return "A loja selecionada não pertence ao seu cliente. Selecione outra loja ou fale com o suporte.";
    case "pedido não encontrado. recarregue a página.":
      return ORDER_NOT_FOUND;
    default:
      break;
  }

  if (isOrderRequiresChangeRequestConflict(error)) {
    return "Este pedido já foi concluído. Solicite uma alteração para incluir este item.";
  }

  return getUserFacingErrorMessage(error);
}
